import clsx from "clsx";
import "./Toggle.scss";

interface Props {
  checked: boolean;
  checkedName: string;
  unCheckedName: string;
  disabled?: boolean;
  label: string | React.ReactNode;
  alert?: string;
  onToggle: () => void;
  className?: string;
}
export default function Toggle({
  checked,
  disabled,
  label,
  alert,
  onToggle,
  className,
}: Props) {
  const handleToggle = () => {
    if (!disabled) onToggle();
  };

  return (
    <div className={clsx("toggle-container", className)}>
      <div className="toggle">
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: TODO: replace with button */}
        <div
          id="button-body"
          className={`pill ${checked ? "active-pill" : ""} ${disabled ? "toggle-disabled" : ""}`}
          onClick={handleToggle}
        >
          <div className={`pip ${checked ? "active-pip" : ""}`} />
        </div>
        <label className="fw-bold small" htmlFor="button-body">
          {label}{" "}
        </label>
        {alert && <div className="toggle-alert">{alert}</div>}
      </div>
    </div>
  );
}
